<template>
  <div>
    <el-upload
      ref="upload"
      slot="append"
      multiple
      :show-file-list="false"
      action="#"
      :disabled="isUploading"
      :auto-upload="true"
      :http-request="upload"
    >
      <slot name="default"></slot>
    </el-upload>
    <el-dialog
      :visible.sync="isUploading"
      :show-close='false'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <p style="font-size: 16px;line-height:1;text-align: center;">
        文件上传中<i class="el-icon-loading" style="margin-left: 5px"></i>
      </p>
      <el-progress
        style="margin-top: 30px"
        :text-inside="true"
        :stroke-width="20"
        :percentage="percentage"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import request from "axios";
import partUpload from "@/utils/uploadPartUtils";
export default {
  data() {
    return {
      isUploading: false,
      percentage: 0,
    };
  },
  methods: {
    upload(up) {
      const vm = this;
      if (up.file) {
        this.isUploading = true;
        if (up.file.size / 1024 / 1024 < 2) {
          let formData = new FormData();
          formData.append("file", up.file);
          request.post(`${process.env.VUE_APP_API_DOMAIN}/upload`, formData).then((res) => {
            this.isUploading = false;
            vm.$emit("success", res.data.data);
            this.$emit("input", res.data.data.url);
            this.$refs.upload.clearFiles();
          });
        } else {
          const upload = partUpload({
            onUploadProgress(current) {
              vm.percentage = Math.floor(current * 100);
            },
            onUploadSucceed(file) {
              vm.$emit("input", file.url);
              vm.$emit("success", file);
              vm.$refs.upload.clearFiles();
              vm.isUploading = false;
            },
          });

          upload.addFile(up.file);
          upload.startUpload();
        }
      }
      vm.percentage = 0;
    }
  },
};
</script>
